<template>
  <crud-update :open="open"
               :loading="loading"
               :title="title"
               :errorMessage="errorMessage"
               @update="update"
               @close="$emit('close')"
  >
    <promo-form ref="form" v-model="form" :input-errors="inputErrors" @save="update"/>
  </crud-update>
</template>

<script>

import PromoProvider from "../../../../providers/PromoProvider";

import {CrudUpdate, ClientError} from '@dracul/common-frontend'

import PromoForm from "../../../../forms/PromoForm";


export default {
  name: "PromoUpdate",

  components: {PromoForm, CrudUpdate},

  props: {
    open: {type: Boolean, default: true},
    item: {type: Object, required: true}
  },

  data() {
    return {
      title: 'delivery.promo.editing',
      errorMessage: '',
      inputErrors: {},
      loading: false,
      id: this.item.id,
      form: {
        name: this.item.name,
        price: this.item.price,
        active: this.item.active,
        mode: this.item.mode ? this.item.mode : [],
        calendar: this.item.calendar ? this.item.calendar.id : null,
        image: this.item.image,
        config: this.item.config ? this.item.config.map(c => ({
              category: c.category.id,
              quantity: c.quantity,
              products: c.products.map(p => p.id)
        })) : [],
      }
    }
  },
  methods: {
    update() {
      if (this.$refs.form.validate()) {
        this.loading = true
        PromoProvider.updatePromo(this.id, this.form).then(r => {
              if (r) {
                this.$emit('itemUpdated', r.data.updatePromo)
                this.$emit('close')
              }
            }
        ).catch(error => {
          let clientError = new ClientError(error)
          this.inputErrors = clientError.inputErrors
          this.errorMessage = clientError.i18nMessage
        }).finally(() => this.loading = false)
      }

    }
  },
}
</script>

<style scoped>

</style>

